import { updateCart, updateCartProduct } from '../ajax';
import { orderUpdateState } from '../order';
/**
 * @param {number} productId
 */
export const updateProduct = (productId) => {
  orderUpdateState(true);
  try {
    (async () => {
      const currentProduct = window.Dio.SHOP.CART
        .getAllProducts().find(product => product.id === productId);
      if (currentProduct) {
        updateCartProduct({
          productId: currentProduct.id,
          count: currentProduct.count,
          check: currentProduct.wish,
        }).then(() => {
          orderUpdateState(false);
        });
      } else {
        window.location.reload();
      }
    })();
  } catch (error) {
    console.log(error);
  }
};

/**
 * @param { Product[] } products
 */
export const updateManyProducts = (products) => {
  orderUpdateState(true);
  try {
    const productsAjax = products.map(product => ({
      productId: product.id,
      count: product.count,
      check: product.wish,
    }));
    updateCart(productsAjax).then(() => {
      orderUpdateState(false);
    });
  } catch (error) {
    console.log(error);
  }
};
